import {v4 as uuidv4} from 'uuid';

export default (data) => ({
    ...data,
    id: uuidv4(),
});
